import * as React from 'react';
import {FunctionComponent} from 'react';
import {CompareReport} from './Compare/CompareReport';
import {useSearchParams} from 'react-router-dom';

interface OwnProps {}

export const ReportShowPreviewContainer: FunctionComponent<OwnProps> = ({}) => {
    const [searchParams] = useSearchParams();
    const snippetCollectionIds = searchParams.get('snippetCollectionIds');
    const userIds = searchParams.get('userIds');
    const crewIds = searchParams.get('crewIds');
    const from = searchParams.get('from');
    const till = searchParams.get('till');

    return (
        <CompareReport
            snippetCollectionIds={snippetCollectionIds?.split(',').map((value) => parseInt(value, 10)) ?? []}
            userIds={userIds?.split(',').map((value) => parseInt(value, 10)) ?? []}
            crewIds={crewIds?.split(',').map((value) => parseInt(value, 10)) ?? []}
            dateRange={{from: from ? new Date(from) : null, till: till ? new Date(till) : null}}
        />
    );
};
